import React, { useEffect } from 'react'

import Flex from 'ds/Flex'
import { BrandIcons } from './BrandIcons'
import { Wrapper } from 'components/ArticleComponents'
import { useLayoutContext } from 'components/LayoutContext'
import useTableOfContents from 'hooks/useTableOfContents'

function toPageTitleSuffix(pathname) {
	const lastSubpath = pathname.split('/').slice(-1)[0]

	if (['drop-in', 'headless'].includes(lastSubpath)) return ` ${lastSubpath}`

	return ''
}

export const PaymentMethodGuide = ({ children, location, description, paymentMethod, processor }) => {
	const { directIntegration, icon, fullPaymentMethodName } = processor
	const title = fullPaymentMethodName + toPageTitleSuffix(location.pathname)

	const { setLayoutProps } = useLayoutContext()

	const tableOfContents = useTableOfContents([location.search, location.pathname])

	useEffect(() => {
		setLayoutProps({
			seoProps: { title },
			showBreadcrumbs: true,
			topSectionProps: {
				title: (
					<Flex justify='flex-start' align='baseline'>
						<BrandIcons paymentMethodSrc={paymentMethod.icon} processorSrc={directIntegration ? null : icon} />
						{title}
					</Flex>
				),
				description,
			},
			tocValue: { items: tableOfContents }, //TODO: update with the change of platform
			modSlug: 'slug',
			tableOfContentsMaxDepth: 5,
		})
	}, [paymentMethod, processor])

	return <Wrapper>{children}</Wrapper>
}
